import { render, staticRenderFns } from "./FormBasico.vue?vue&type=template&id=3f5eb800&"
import script from "./FormBasico.vue?vue&type=script&lang=js&"
export * from "./FormBasico.vue?vue&type=script&lang=js&"
import style0 from "./FormBasico.vue?vue&type=style&index=0&id=3f5eb800&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports